import { render, staticRenderFns } from "./listgastos.vue?vue&type=template&id=5d5d2826&"
import script from "./listgastos.vue?vue&type=script&lang=js&"
export * from "./listgastos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports